export const OWN_SHIPPING_CARRIER_ID = 'own-shipping'
